import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Alert } from './shared/formState/model/alert';
import * as authenticationActions from './shared/state/actions/authentication.action';
import * as fromShared from './shared/state/reducers';
import * as fromAlertSelectors from './shared/state/selectors/form-state.selectors';
import * as fromTitleSelectors from './shared/state/selectors/title.selectors';
import * as alertActions from './shared/state/actions/form-state.actions';
import { AuthenticationConstants } from './shared/constants';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  alert$: Observable<Alert>;
  title$: Observable<string>;
  subscription: Subscription;

  constructor(private sharedStore: Store<fromShared.State>, private titleService: Title) {
  }

  ngOnInit() {
    this.login();

    this.subscription = this.title$.subscribe(t => this.titleService.setTitle(`ATS - ${t}`));
  }


  login() {

    const applicantToken = localStorage.getItem(AuthenticationConstants.APPLICANT_TOKEN);
    const applicantExpiresAt = localStorage.getItem(AuthenticationConstants.APPLICANT_EXPIRES_AT);

    this.alert$ = this.sharedStore.pipe(select(fromAlertSelectors.GetFormAlert))
    this.title$ = this.sharedStore.pipe(select(fromTitleSelectors.GetTitle))

    if (applicantToken && applicantExpiresAt && new Date() < new Date(applicantExpiresAt)) {
      this.sharedStore.dispatch(authenticationActions.LoggedInApplicant({ data: { token: applicantToken, expiresAt: applicantExpiresAt } }));
    }
    else {
      const userToken = localStorage.getItem(AuthenticationConstants.USER_TOKEN);
      const userExpiresAt = localStorage.getItem(AuthenticationConstants.USER_EXPIRES_AT);

      if (userToken && userExpiresAt && new Date() < new Date(userExpiresAt)) {
        this.sharedStore.dispatch(authenticationActions.LoggedInUser({data:{ token: userToken, expiresAt: userExpiresAt }}));
      }
    }
  }
   
  closeAlert(): void {
    this.sharedStore.dispatch(alertActions.FormClearAlert());
  }
}
